import {useQuery} from "react-query";
import {Client, FleetSensorReliabilitySummary} from "../../autogenerate/api.generated.clients";
import {UseQueryResult} from "react-query/types/react/types";

export const useSensorReliability = (filter?: string) : UseQueryResult<FleetSensorReliabilitySummary> => {
    return useQuery(['fleet-sensor-reliability', filter], async () => {
        const orgId = filter ? Number(filter) : null;
        return new Client().sensorReliability_GetFleetSensorReliabilityReport(orgId);
    }, {refetchOnWindowFocus: false});
}